import React, { useEffect } from 'react';
import {Users, Baby, Calendar, MapPin, FileText} from 'lucide-react';
import { useTranslation } from "react-i18next";

const ResultsTabs = ({ activeTab, setActiveTab, results }) => {
    const { t } = useTranslation();

    const tabs = [
        {
            id: 'name',
            label: t('resultsPage.people'),
            mobileLabel: t('resultsPage.people'),
            matches: results.facets.nameMatches,
            icon: Users
        },
        {
            id: 'birth',
            label: t('resultsPage.birth'),
            mobileLabel: t('resultsPage.birth'),
            matches: results.facets.birthMatches,
            icon: Baby
        },
        {
            id: 'death',
            label: t('resultsPage.death'),
            mobileLabel: t('resultsPage.death'),
            matches: results.facets.deathMatches,
            icon: Calendar
        },
        {
            id: 'place',
            label: t('resultsPage.place'),
            mobileLabel: t('resultsPage.place'),
            matches: results.facets.placeMatches,
            icon: MapPin
        },
        {
            id: 'document',
            label: t('resultsPage.documents'),
            mobileLabel: t('resultsPage.documents'),
            matches: results.facets.documentMatches,
            icon: FileText
        }
    ];

    const findFirstTabWithResults = () => {
        return tabs.find(tab => tab.matches?.length > 0)?.id || 'name';
    };

    useEffect(() => {
        const currentTabHasResults = tabs.find(tab => tab.id === activeTab)?.matches?.length > 0;

        if (!currentTabHasResults) {
            setActiveTab(findFirstTabWithResults());
        }
    }, [results, activeTab, setActiveTab, tabs]);

    return (
        <div className="flex justify-start mb-4 sm:mb-6">
            <div className="w-[85%] max-w-full overflow-x-auto pb-2 hide-scrollbar">
                <div className="flex gap-2 sm:gap-4 justify-end min-w-min">
                    {tabs.map(tab => {
                        const hasResults = tab.matches?.length > 0;
                        const Icon = tab.icon;
                        return (
                            <button
                                key={tab.id}
                                onClick={() => setActiveTab(tab.id)}
                                className={`
                                    px-3 sm:px-4 py-2 rounded-lg transition-all duration-200
                                    flex items-center gap-1 sm:gap-2 whitespace-nowrap
                                    text-sm sm:text-base
                                    ${activeTab === tab.id
                                    ? 'bg-[#8B5E3C] text-white shadow-md'
                                    : hasResults
                                        ? 'bg-[#e6dfd4] text-[#4a3f30] hover:bg-[#d4c8b8]'
                                        : 'bg-[#f0ebe4] text-[#937c5d] cursor-default'
                                }
                                    ${hasResults ? 'hover:scale-105' : 'opacity-60'}
                                `}
                                disabled={!hasResults}
                            >
                                <Icon className="w-4 h-4"/>
                                <span className="hidden sm:inline">{tab.label}</span>
                                <span className="sm:hidden">{tab.mobileLabel}</span>
                                {hasResults && (
                                    <span className={`
                                        text-xs sm:text-sm px-1.5 sm:px-2 py-0.5 rounded-full 
                                        ${activeTab === tab.id
                                        ? 'bg-white/20 text-white'
                                        : 'bg-[#8B5E3C]/10 text-[#8B5E3C]'
                                    }
                                    `}>
                                        {tab.matches.length}
                                    </span>
                                )}
                            </button>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default ResultsTabs;